export enum LoanPurposeHow {
  WITH_DEVELOPER = 'WithDeveloper',
  ON_YOUR_OWN = 'OnYourOwn',
}
